import { useEffect, useRef, useState } from 'react';
import './ExperienceSection.css';

const pillars = [
  {
    icon: 'ri-focus-3-line',
    title: 'Precisión',
    description:
      'Cada línea, cada fade, cada detalle ejecutado con técnica milimétrica. No hay margen para lo mediocre.',
  },
  {
    icon: 'ri-palette-line',
    title: 'Estilo',
    description:
      'Tu corte es una extensión de tu identidad. Trabajamos contigo para crear un look que sea auténticamente tuyo.',
  },
  {
    icon: 'ri-vip-crown-line',
    title: 'Experiencia',
    description:
      'Desde que entras hasta que sales, cada momento está diseñado para que te sientas en un nivel diferente.',
  },
];

export default function ExperienceSection() {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      ref={ref}
      className="experience-section py-24 md:py-32 relative overflow-hidden"
    >
      {/* Subtle top border */}
      <div className="experience-section-top-line absolute top-0 left-0 right-0" />

      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div
          className={`text-center mb-16 transition-all duration-700 ${
            visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="experience-section-label mb-4">
            ◆ Nuestra Filosofía ◆
          </p>
          <h2 className="experience-section-title">
            Lo que nos define
          </h2>
          <div className="experience-section-divider" />
        </div>

        {/* 3 Columns */}
        <div className="experience-grid">
          {pillars.map((pillar, idx) => (
            <div
              key={pillar.title}
              className="experience-card"
              style={{
                opacity: visible ? 1 : 0,
                transform: visible ? 'translateY(0)' : 'translateY(32px)',
                transitionDelay: `${idx * 150}ms`,
              }}
            >
              {/* Icon */}
              <div className="experience-icon-wrapper mb-8">
                <div className="experience-icon-ring" />
                <i className={`${pillar.icon} experience-icon`} />
              </div>

              {/* Number */}
              <p className="experience-number">
                0{idx + 1}
              </p>

              {/* Title */}
              <h3 className="experience-title">
                {pillar.title}
              </h3>

              {/* Divider */}
              <div className="experience-divider" />

              {/* Description */}
              <p className="experience-description">
                {pillar.description}
              </p>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom border */}
      <div className="experience-section-bottom-line absolute bottom-0 left-0 right-0" />
    </section>
  );
}